export function algoliaQueryStringFilter(
  facet: string,
  value: string | undefined,
) {
  return value ? `${facet}:'${value}'` : '';
}
